import React from "react";
import my_pic from "../images/photo.jpeg"
import { FaTwitter, FaInstagram, FaGithub, FaLinkedinIn } from "react-icons/fa"
import { Link } from "react-router-dom";


export default function About(props) {
    return (
        
        <div className="hero-section">
        <div className="hero-section-cards">
            <div className="hero-section-card">
                <div className="hero-section-bio" id="aboutme">
                    <img src={my_pic} alt="me" className="my_pic"></img>
                    <h5 className="my-name">{props.name}</h5><hr></hr>
                    <h6 className="my-title">{props.title}</h6>
                </div>
                <ul className="bio-social-icons">
                <li><a href="https://github.com/stevomusembi" target="_blank"><FaGithub /></a></li>
                <li><a href="https://www.linkedin.com/in/stevenmusembi" target="_blank"> <FaLinkedinIn /></a></li>
                <li><a href="https://twitter.com/voshtty" target="_blank"> <FaTwitter /></a></li>
                <li><a href="https://www.instagram.com/steven_musembi/" target="_blank"> <FaInstagram /></a></li>
                </ul>
            </div>
            <div className="hero-section-card">
                <div className="hero-section-about">
                    <h4 className="about-title">Hello</h4>
                    <div className="button-section">
                       <a href="" target="_blank"><button className="buttons btn1"> RESUME</button></a>
                        <Link to= "/projects"> <button className="buttons btn2">PROJECTS</button></Link>

                    </div>
                    <p className="about-me">
                    <br></br>Hello, I'm Steven Musembi, a Software Developer<br></br> based in Nairobi, Kenya.<br></br>
                        <br></br>
                        I enjoy discovering how things work and the process of  <br></br>learning new technologies that I can apply to my work <br></br> and personal projects..<br></br><br/>
                    </p>

                </div>
            </div>
            <div className="hero-section-card">
                <div className="hero-section-skills">
                    <h4 className="skills-title">Skills</h4>
                    <ul className="skills">
                        <li><span class="material-symbols-outlined bullet2">square</span>ReactJs</li>
                        <li><span class="material-symbols-outlined bullet2">square</span>JavaScript</li>
                        <li><span class="material-symbols-outlined bullet2">square</span>Git</li>
                        <li><span class="material-symbols-outlined bullet2">square</span>TailwindCSS</li>
                        <li><span class="material-symbols-outlined bullet2">square</span>Bootstrap</li>
                        <li><span class="material-symbols-outlined bullet2">square</span>Wordpress</li>
                    </ul>
                </div>
            </div>
        </div>
        </div>
    )
}